import React from "react";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useIntl } from "react-intl";

import DateRangeType from "@mapmycustomers/shared/types/range/DateRange";

import { DefaultDateRangeConfiguration } from "@app/types/dashboard/CardConfiguration";
import { CheckInsPreferences } from "@app/types/dashboard/cards/checkIns/CheckInsCardConfiguration";

import useChartConfig from "./useChartConfig";

interface Props {
  className?: string;
  dateRange: DefaultDateRangeConfiguration;
  history: Array<{ date: Date; unverifiedCount?: number; verifiedCount: number }>;
  includeUnverifiedCheckIns?: boolean;
  onPointClick?: (range: DateRangeType, reliability?: boolean) => void;
  preferences: CheckInsPreferences;
  previousHistory?: Array<{ date: Date; unverifiedCount?: number; verifiedCount: number }>;
  showGoal?: number;
}

const Chart: React.FC<Props> = ({
  className,
  dateRange,
  history,
  includeUnverifiedCheckIns,
  onPointClick,
  preferences,
  previousHistory,
  showGoal,
}) => {
  const intl = useIntl();
  const chartConfig = useChartConfig(
    preferences,
    history,
    previousHistory,
    dateRange,
    includeUnverifiedCheckIns ?? false,
    intl,
    onPointClick,
    showGoal
  );

  return (
    <HighchartsReact
      containerProps={{ className }}
      highcharts={Highcharts}
      isPureConfig
      options={chartConfig}
    />
  );
};

export default Chart;
